'use client'

import { useSessionAwareOnboardingQuery } from '@/lib/features/user/userApi'

export function useOnboardingCheck() {
  const { data: onboardingData, isLoading } = useSessionAwareOnboardingQuery()

  // TEMPORARILY DISABLED FOR TESTING: Redirect to onboarding if not completed
  // useEffect(() => {
  //   if (!isLoading && onboardingData && !onboardingData.onboardingCompleted) {
  //     router.push('/onboarding')
  //   }
  // }, [onboardingData, isLoading, router])

  return {
    needsOnboarding: !isLoading && onboardingData && !onboardingData.onboardingCompleted,
    isLoading,
    onboardingData,
  }
}
